module.exports = __webpack_public_path__ + "static/img/erweima.89d2b690.png";